






























































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import LeftNavigationComponent from "@/components/App/Modules/GMS/Workspace/Components/LeftNavigation.vue";
import AutoCompleteForm from "./AutoCompleteForm.vue";
import DocumentForm from "./DocumentForm.vue";
import VJsonschemaForm from "@pan-gms/vuetify-jsonschema-form";
import { MigrationImport } from "@/entities";
import NavigationButtons from "@/components/App/Modules/GMS/Workspace/Components/NavigationButtons.vue";

const namespace: string = "migration";

@Component({
  components: {
    VJsonschemaForm,
    AutoCompleteForm,
    LeftNavigationComponent,
    DocumentForm,
    NavigationButtons,
  },
})
export default class BasicInfoFormComponent extends Vue {
  @State(namespace) migration!: MigrationImport;

  @Prop() schema!: any;
  @Prop() users!: any;
  @Prop() tags!: any;
  @Prop() appData!: any;
  @Prop() subKey!: any;
  @Prop() rootSchema: any;
  @Prop() isDirty!: boolean;

  showSideBar = true;

  change(e) {}

  subMenuChanged(selectedMenu, key) {
    this.$emit("subMenuChanged", key);
  }

  get subSchema() {
    if (this.subKey) {
      return this.schema.properties[this.subKey];
    } else {
      return this.subSchema;
    }
  }

  showInput(e) {
    this.$emit("input", true);
  }

  sidebarToggle() {
    this.showSideBar = !this.showSideBar;
  }
}
